import { useFormik } from "formik";
import React, { useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

import { postUserSendEmailValidation } from "../../../helpers/backend_helper";
import dayjs from "dayjs";

const ValidateEmail = ({ userValidation }) => {
  const [pinSent, setPinSent] = useState("");
  const [modal, setModal] = useState({
    show: false,
  });
  const [isSendingPing, setIsSendingPin] = useState(false);

  const user = userValidation.values;
  const isValidEmail = user.email && !userValidation.errors.email;

  const onSubmit = (formValues) => {
    if (pinSent != formValues.pin) {
      validation.setFieldError("pin", "El PIN ingresado es incorrecto");
      return;
    }

    const todayStr = dayjs().format("YYYY-MM-DD HH:mm");

    userValidation.setFieldValue("email_verified_at", todayStr);

    modalToggle();
  };

  const validation = useFormik({
    initialValues: {
      pin: "",
    },
    validationSchema: Yup.object({
      pin: Yup.string().required().label("PIN"),
    }),
    onSubmit,
  });

  const modalToggle = () => {
    setModal({ show: !modal.show });
  };

  const sendPin = () => {
    setIsSendingPin(true);

    postUserSendEmailValidation({
      email: user.email,
      id: userValidation.values.id,
      type: "concesionario",
    })
      .then((resp) => {
        setPinSent(resp.pin);
      })
      .finally(() => {
        setIsSendingPin(false);
      });
  };

  return (
    <>
      {user.email_verified_at ? (
        <div className="input-group-text bg-white">
          <i
            title="Teléfono validado"
            className="fas fa-check-circle text-success"
          ></i>
        </div>
      ) : (
        <div
          className="input-group-text bg-white"
          style={{ cursor: isValidEmail ? "pointer" : "not-allowed" }}
          role="button"
          onClick={() => {
            if (!isValidEmail) return;

            validation.resetForm();
            modalToggle();
            sendPin();
          }}
          title="Validar por Whats App"
        >
          <i
            title="Validar teléfono"
            className={`fas fa-mail-bulk ${isValidEmail && "text-success"}`}
          ></i>
        </div>
      )}
      {modal.show && (
        <Modal isOpen={modal.show}>
          <ModalHeader className="bg-primary">
            Validar correo electrónico
          </ModalHeader>
          <ModalBody>
            {isSendingPing ? (
              <div className="text-center">
                <Spinner size="sm" />
                <p>Enviando correo electrónico</p>
              </div>
            ) : (
              <div className="text-center">
                <i
                  title="Teléfono validado"
                  className="fas fa-check-circle text-success fs-2"
                ></i>
                <p>Correo electrónico enviado</p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            {/* <Button
              form="validate-phone-form"
              color="primary"
              type="button"
              disabled={isSendingPing}
              onClick={() => {
                validation.handleSubmit();
              }}
            >
              <i className="fa fa-save"></i> Guardar
            </Button>{" "} */}
            <Button
              color="secondary"
              onClick={modalToggle}
              disabled={isSendingPing}
            >
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default ValidateEmail;
